const defaultState = {
    formSubmitFailed: false,
    formSubmitted: false,
};

export function extendStudentInsuranceTeaserData(state = defaultState, action) {
    switch (action.type) {
        case 'STUDENT_SPECIAL_TEASER_LOADED':
            return { ...state, ...action.data };
        break;
        case 'STUDENT_SPECIAL_PAYMENT_METHOD_LOADED':
            return { ...state, paymentMethod: action.data };
        break;
        case 'STUDENT_SPECIAL_TEASER_FORM_SUBMIT_FAILURE':
            return { ...state, formSubmitFailed: !!action.data };
        break;
        case 'STUDENT_SPECIAL_TEASER_FORM_SUBMITTED':
            return { ...state, formSubmitted: !!action.data.submitted, automaticForm: !!action.data.automatic };
        break;
        default:
            return state;
    }
}